// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.login-container {
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #ffffff 0%, #47a3ff 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.login-card {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  width: 100%; 
  max-width: 1000px;
}

/* Исправление ширины карточки */
.ant-card {
  width: 100% !important;
  max-width: 1000px !important;
}

/* Стили для мобильных устройств */
@media (max-width: 576px) {
  .login-container {
    padding: 16px;
  }
  
  .login-card {
    width: 100%;
    max-width: none;
  }
}

/* Заголовок и содержимое карточки */
.login-card .ant-card-head {
  border-bottom: none;
  padding-bottom: 0;
  width: 100%;
}

.login-card .ant-card-body {
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
}

/* Исправление для кнопок, чтобы занимали всю ширину */
.login-card .ant-btn {
  width: 100%;
  transition: all 0.3s ease;
}

/* Стили для кнопки Google */
.login-card .ant-btn-default {
  background-color: white;
  color: #333;
  border-color: #ddd;
}

/* Первичная кнопка входа */
.login-card .ant-btn-primary {
  background: linear-gradient(90deg, #1890ff, #096dd9);
  border: none;
}

/* Исправление для полей ввода */
.login-card .ant-input-affix-wrapper {
  width: 100%;
  box-sizing: border-box;
}

/* Исправление для формы */
.login-card form {
  width: 100%;
}

/* Исправление для строки кнопок */
.login-card .ant-space {
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* Сброс нежелательных стилей, которые могут сжимать компоненты */
.ant-col {
  max-width: 100% !important;
}

.ant-row {
  width: 100% !important;
  max-width: 1000px !important;
}

.ant-typography.nickname.css-dev-only-do-not-override-240cud{
  color: #ffffff !important;
}
.ant-row.css-dev-only-do-not-override-upbfpk{
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":";;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,6DAA6D;EAC7D,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA,iEAAiE;AACjE;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB","sourcesContent":["\r\n\r\n.login-container {\r\n  min-height: 100vh;\r\n  width: 100%;\r\n  background: linear-gradient(135deg, #ffffff 0%, #47a3ff 100%);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.login-card {\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\r\n  border-radius: 8px;\r\n  width: 100%; \r\n  max-width: 1000px;\r\n}\r\n\r\n/* Исправление ширины карточки */\r\n.ant-card {\r\n  width: 100% !important;\r\n  max-width: 1000px !important;\r\n}\r\n\r\n/* Стили для мобильных устройств */\r\n@media (max-width: 576px) {\r\n  .login-container {\r\n    padding: 16px;\r\n  }\r\n  \r\n  .login-card {\r\n    width: 100%;\r\n    max-width: none;\r\n  }\r\n}\r\n\r\n/* Заголовок и содержимое карточки */\r\n.login-card .ant-card-head {\r\n  border-bottom: none;\r\n  padding-bottom: 0;\r\n  width: 100%;\r\n}\r\n\r\n.login-card .ant-card-body {\r\n  padding: 24px;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Исправление для кнопок, чтобы занимали всю ширину */\r\n.login-card .ant-btn {\r\n  width: 100%;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n/* Стили для кнопки Google */\r\n.login-card .ant-btn-default {\r\n  background-color: white;\r\n  color: #333;\r\n  border-color: #ddd;\r\n}\r\n\r\n/* Первичная кнопка входа */\r\n.login-card .ant-btn-primary {\r\n  background: linear-gradient(90deg, #1890ff, #096dd9);\r\n  border: none;\r\n}\r\n\r\n/* Исправление для полей ввода */\r\n.login-card .ant-input-affix-wrapper {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Исправление для формы */\r\n.login-card form {\r\n  width: 100%;\r\n}\r\n\r\n/* Исправление для строки кнопок */\r\n.login-card .ant-space {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* Сброс нежелательных стилей, которые могут сжимать компоненты */\r\n.ant-col {\r\n  max-width: 100% !important;\r\n}\r\n\r\n.ant-row {\r\n  width: 100% !important;\r\n  max-width: 1000px !important;\r\n}\r\n\r\n.ant-typography.nickname.css-dev-only-do-not-override-240cud{\r\n  color: #ffffff !important;\r\n}\r\n.ant-row.css-dev-only-do-not-override-upbfpk{\r\n  justify-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
